import React, { useState, useEffect } from "react";
import { Link, useHistory, useLocation, Switch } from "react-router-dom";
import { Pagination } from "react-bootstrap";
import { ProgressBar } from "react-bootstrap";
import { Grid, Button } from "@material-ui/core";
import { Modal } from "react-bootstrap";
import { getMyLicenseList, insertReq } from "../../api";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import * as auth from "../_redux/authRedux";
import Moment from "moment";
import LayoutAuth from "./Layout";

export function LicenseList(props) {
  // console.log("LicenseList", props);

  // const { intl } = props;
  const [loading, setLoading] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [isExtensionShow, setIsExtensionShow] = useState(false);
  const [myLicenseList, setMyLicenseList] = useState([]);
  const [expireList, setExpireList] = useState();
  const history = useHistory();
  const location = useLocation();
  const [contents, setContents] = useState();
  const [licenseNo, setLicenseNo] = useState();
  const [licenseNumber, setLicenseNumber] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getMyLicenseList();
        if (result.data.map !== undefined) {
          console.log("result", result);
          setMyLicenseList(result.data);

          let list = [];
          result.data.map((data, index) => {
            if (data.remainDays < 0) {
              list.push(data);
            }
          });
          setExpireList(list);
        }
      } catch (e) {
        console.log(e);
        // Handle error
      }
    };
    fetchData();
  }, []);

  // console.log("setExpireList", expireList);

  const toggleShow = () => {
    setIsShow(!isShow);
  };

  const toggleExtension = () => {
    setIsExtensionShow(!isExtensionShow);
  };

  const doStart = () => {
    const role = localStorage.getItem("userRole");
    if (role !== "SystemAdmin") {
      if (myLicenseList.length === 0) {
        alert(
          "라이선스 구매 후 시작 가능합니다.\n라이선스 구매 문의하기를 이용해 주세요."
        );
        return false;
      }
    }

    // props.login(localStorage.getItem("token"));
    history.push("/main");
    // history.push("/main");
  };

  const list = myLicenseList.map((data, index) => {
    // console.log("myLicenseList", data);
    let useDays = Moment(data.endAt).diff(data.startAt, "days");
    let todayDiff = Moment(new Date()).diff(data.startAt, "days");
    let usedDays;
    let expireText;
    if (todayDiff < 0) {
      usedDays = 0;
    } else if (todayDiff > useDays) {
      usedDays = useDays;
      expireText = "기간만료";
    } else {
      usedDays = todayDiff;
    }
    // 소수점일경우 Math.floor 하면 실수로 바껴서 표현 안됨
    let useRate = isNaN((usedDays / useDays) * 100)
      ? 0
      : (usedDays / useDays) * 100;

    // console.log(useRate);

    return (
      <li className="mb-5">
        <p className="mb-0 license-number">
          {data.licenseNumber} ({data.botAmount}bot for {useDays}days)
        </p>
        <small className="mb-1 mt-1 d-flex text-muted">
          <span style={{ paddingTop: "2px", marginRight: "10px" }}>
            {Moment(data.startAt).format("YY-MM-DD")} –{" "}
            {Moment(data.endAt).format("YY-MM-DD")}
          </span>
          <span style={{ paddingTop: "2px" }}> {expireText}</span>
          <span
            style={{ marginLeft: "15px", cursor: "pointer" }}
            className={"label label-inline label-success"}
            onClick={() => {
              toggleExtension();
              setLicenseNo(data.no);
              setLicenseNumber(data.licenseNumber);
            }}
          >
            연장
          </span>
        </small>
        <div className="progress-wrap d-flex align-items-center justify-content-between">
          <div className="w-100">
            <ProgressBar now={useRate} />
          </div>

          <p className="mb-0 ml-2 days text-right">
            {usedDays} / {useDays}days
          </p>
        </div>
      </li>
    );
  });

  const regReq = async () => {
    if (contents === undefined) {
      alert("문의 내용을 입력해 주세요.");
      return false;
    }
    if (window.confirm("작성하신 대로 문의 하시겠습니까?")) {
      toggleExtension();

      const param = {
        userNo: localStorage.getItem("userNo"),
        contents: contents,
        type: "extend",
        licenseNo: licenseNo,
      };

      const res = await insertReq(param);
      // console.log("resres", res);

      if (res.result) {
        alert("문의가 정상적으로 접수되었습니다.");
        setContents("");
        return;
      } else {
        alert("문의가 정상적으로 접수되지 않았습니다.");
        return false;
      }
    }
  };

  return (
    <LayoutAuth>
      <div className="card card-custom px-10 py-10" id="pageid19">
        <Modal show={isShow}>
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              구매하기
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <h1 className="text-primary mb-5">X</h1>
            <span>라이선스를 선택해 주세요.</span>
          </Modal.Body>
          <Modal.Footer>
            <div>
              <button
                type="button"
                onClick={toggleShow}
                className="btn btn-primary btn-elevate"
              >
                확인
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        <Modal show={isExtensionShow}>
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              라이선스 연장 문의
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                marginBottom: "20px",
                textAlign: "right",
                color: "gray",
              }}
            >
              아래와 같이 요청을 주시면, 담당자가 확인 후 연락 드립니다.
            </div>
            <p>라이선스</p>
            <div className="form-group fv-plugins-icon-container">
              <div className="d-flex align-items-center justify-content-between">
                <input
                  placeholder=""
                  type="text"
                  className={`form-control form-control-solid h-auto py-5 px-6 `}
                  name="licenseNumber"
                  disabled
                  value={licenseNumber}
                />
              </div>
            </div>
            <p>문의 내용</p>
            <div className="form-group fv-plugins-icon-container">
              <textarea
                maxlength="1500"
                className="modal-textarea"
                name="contents"
                value={contents}
                onChange={(e) => setContents(e.target.value)}
              ></textarea>
              {contents != null ? (
                <span>{contents.length}/1500</span>
              ) : (
                <span>0/1500</span>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div>
              <button
                type="button"
                onClick={toggleExtension}
                className="btn btn-light btn-elevate"
              >
                취소
              </button>
              <> </>
              <button
                type="button"
                onClick={regReq}
                className="btn btn-primary btn-elevate"
              >
                문의
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        <div className="card-header border-0 align-items-center justify-content-between px-0">
          <h2 className="flex-column">AIMILY Solution</h2>
          <div className="card-toolbar">
            <button
              id="join-success"
              // type="submit"
              className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
              onClick={doStart}
            >
              <span>시작 하기</span>
              {loading && <span className="ml-3 spinner spinner-white"></span>}
            </button>
          </div>
        </div>
        <div className="license d-flex flex-center align-items-center justify-content-center mb-4">
          <span>라이선스</span>
        </div>
        <div className="text-right mb-7">
          <Link
            to="/licenseList"
            className="font-size-h6 text-hover-primary mr-3"
            style={{ fontWeight: "bold" }}
          >
            라이선스 전체 보기
          </Link>
          <Link
            to="/buyLicense"
            // to={{ pathname: "/buyLicense", state: { obj: props } }}
            className="font-size-h6 text-hover-primary"
            style={{ fontWeight: "500" }}
          >
            라이선스 구매 문의하기
          </Link>
        </div>

        {/* <!---- 사용 가능한 라이선스가 존재 할 때 ----> */}
        {myLicenseList && myLicenseList.length > 0 ? (
          <div>
            <div className="text-right mb-3">
              <p>
                총 <b>{myLicenseList.length}개</b> 라이선스 중{" "}
                <b>
                  {myLicenseList.length -
                    (expireList && expireList.length > 0
                      ? expireList.length
                      : 0)}
                  개
                </b>
                가 활성화 중이며,{" "}
                <b>
                  {expireList && expireList.length > 0 ? expireList.length : 0}
                  개
                </b>
                가 만료 되었습니다
              </p>
            </div>
            <ul className="mb-15 pl-0">
              {list}
              {/* <li className="mb-5">
                <p className="mb-0 license-number">
                  A234B-EXGWX-Y239B-123AB-TBGEQ (5bot for 30days)
                </p>
                <small className="mb-1 d-flex text-muted">
                  21.05.01 – 21.05.30
                </small>
                <div className="progress-wrap d-flex align-items-center justify-content-between">
                  <div className="w-100">
                    <ProgressBar
                      animated
                      now={100}
                      style={{ height: "10px", width: "40%" }}
                    />
                  </div>
                  <p className="mb-0 ml-2 days text-right">10 / 30days</p>
                </div>
              </li>
              <li className="mb-5">
                <p className="mb-0 license-number">
                  B234B-EXGWX-Y239B-123AB-TBGEQ (5bot for 60days)
                </p>
                <small className="mb-1 d-flex text-muted">
                  21.03.01 – 21.04.30
                </small>
                <div className="progress-wrap d-flex align-items-center justify-content-between">
                  <div className="w-100">
                    <ProgressBar
                      animated
                      now={100}
                      style={{ height: "10px", width: "60%" }}
                    />
                  </div>
                  <p className="mb-0 ml-2 days text-right">30 / 60days</p>
                </div>
              </li>
              <li className="mb-5">
                <p className="mb-0 license-number">
                  C234B-EXGWX-Y239B-123AB-TBGEQ (10bot for 30days)
                </p>
                <small className="mb-1 d-flex text-muted">
                  21.01.01 – 21.01.30
                </small>
                <div className="progress-wrap d-flex align-items-center justify-content-between">
                  <div className="w-100">
                    <ProgressBar
                      animated
                      now={100}
                      style={{ height: "10px", width: "80%" }}
                    />
                  </div>
                  <p className="mb-0 ml-2 days text-right">20 / 30days</p>
                </div>
              </li>
              <li className="mb-5">
                <p className="mb-0 license-number">
                  D234B-EXGWX-Y239B-123AB-TBGEQ (10bot for 30days)
                </p>
                <small className="mb-1 d-flex text-muted">
                  20.12.01 – 20.12.30 기간만료
                </small>
                <div className="progress-wrap d-flex align-items-center justify-content-between">
                  <div className="w-100">
                    <ProgressBar
                      animated
                      now={100}
                      style={{ height: "10px", width: "100%" }}
                    />
                  </div>
                  <p className="mb-0 ml-2 days text-right">30 / 30days</p>
                </div>
              </li> */}
            </ul>
            {/* <div className="d-flex flex-center">
              <Pagination>
                <Pagination.Prev />

                <Pagination.Item>{1}</Pagination.Item>
                <Pagination.Item>{2}</Pagination.Item>
                <Pagination.Item active>{3}</Pagination.Item>
                <Pagination.Item disabled>{4}</Pagination.Item>
                <Pagination.Item>{5}</Pagination.Item>

                <Pagination.Next />
              </Pagination>
            </div> */}
          </div>
        ) : (
          <div className="text-center" style={{ marginTop: 50 }}>
            {myLicenseList && myLicenseList.length === 0 && (
              <p>사용 가능한 라이선스가 존재 하지 않습니다.</p>
            )}
          </div>
        )}

        {/* <!---- 사용 가능한 라이선스가 존재 할 때 ----> */}

        {/* <!---- 사용 가능한 라이선스가 존재하지 않을 때 ----> */}
        {/* {myLicenseList && myLicenseList.length === 0 && } */}

        {/*<!---- 사용 가능한 라이선스가 존재하지 않을 때 ----> */}

        {/* <!---- page id 21 ----> */}
        {/* <div className="pageid21">
          <Grid container spacing={3}>
            <Grid item xs={6} sm={3}>
              <div className="active px-3 py-3 card-rounded text-center my-3">
                <p>5bot for 30days</p>
                <b>100,000 원</b>
              </div>
            </Grid>
            <Grid item xs={6} sm={3}>
              <div className="px-3 py-3 card-rounded text-center my-3">
                <p>5bot for 30days</p>
                <b>100,000 원</b>
              </div>
            </Grid>
            <Grid item xs={6} sm={3}>
              <div className="px-3 py-3 card-rounded text-center my-3">
                <p>5bot for 30days</p>
                <b>100,000 원</b>
              </div>
            </Grid>
            <Grid item xs={6} sm={3}>
              <div className="px-3 py-3 card-rounded text-center my-3">
                <p>5bot for 30days</p>
                <b>100,000 원</b>
              </div>
            </Grid>
            <Grid item xs={6} sm={3}>
              <div className="px-3 py-3 card-rounded text-center my-3">
                <p>5bot for 30days</p>
                <b>100,000 원</b>
              </div>
            </Grid>
            <Grid item xs={6} sm={3}>
              <div className="px-3 py-3 card-rounded text-center my-3">
                <p>5bot for 30days</p>
                <b>100,000 원</b>
              </div>
            </Grid>
            <Grid item xs={6} sm={3}>
              <div className="active px-3 py-3 card-rounded text-center my-3">
                <p>5bot for 30days</p>
                <b>100,000 원</b>
              </div>
            </Grid>
            <Grid item xs={6} sm={3}>
              <div className="px-3 py-3 card-rounded text-center my-3">
                <p>5bot for 30days</p>
                <b>100,000 원</b>
              </div>
            </Grid>
            <Grid item xs={6} sm={3}>
              <div className="px-3 py-3 card-rounded text-center my-3">
                <p>5bot for 30days</p>
                <b>100,000 원</b>
              </div>
            </Grid>
            <Grid item xs={6} sm={3}>
              <div className="px-3 py-3 card-rounded text-center my-3">
                <p>5bot for 30days</p>
                <b>100,000 원</b>
              </div>
            </Grid>
            <Grid item xs={6} sm={3}>
              <div className="active px-3 py-3 card-rounded text-center my-3">
                <p>5bot for 30days</p>
                <b>100,000 원</b>
              </div>
            </Grid>
            <Grid item xs={6} sm={3}>
              <div className="px-3 py-3 card-rounded text-center my-3">
                <p>5bot for 30days</p>
                <b>100,000 원</b>
              </div>
            </Grid>
          </Grid>
          <div className="text-center mt-5">
            <button
              type="submit"
              onClick={toggleShow}
              className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
            >
              <span>구매하기</span>
              {loading && <span className="ml-3 spinner spinner-white"></span>}
            </button>
          </div>
        </div> */}
        {/* <!---- page id 21 ----> */}
      </div>
    </LayoutAuth>
  );
}
// export default LicenseList;
export default injectIntl(connect(null, auth.actions)(LicenseList));
